import styled from "styled-components";

export const LockContentBox = styled.div`
  position: fixed;
  top: 35%;
  left: 50%;
  background: ${({ theme }) => theme.modal.bg.tertiary};
  transform: translate(-50%, 0);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  padding: 2rem 4rem;
  width: 100%;
  max-width: 440px;
  text-align: center;
  border-radius: 10px;
  display: ${(props) => (props.visible ? "block" : "none")};
  z-index: 1050;

  .upgrade-btn {
    width: 100%;
    border-radius: 25px;
  }

  h2 {
    font-weight: 600;
    font-size: 20px;
    margin: 20px 0;
  }

  p {
    font-size: 15px;
  }

  img {
    width: 40px;
    height: 40px;
    margin-bottom: 10px;
  }
`;
